import { useEffect } from 'react';

export const useIsMounted = (cb: VoidFunction) => {
  useEffect(() => {
    cb();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
